<div class="flex flex-col items-center justify-center cnt-box space-y-1">
  <div class="cnt-value">{{ value }}</div>
  <div class="cnt-label">{{ label }}</div>
</div>
